module.exports = __webpack_public_path__ + "assets/img/算法分批2.7f5e820b.jpg";